import React, {useEffect, useRef, useState} from 'react';
import {useSelector} from 'react-redux';
import axios from 'axios';
import Cookies from 'js-cookie';

import * as constants from 'constants/index.js';
import CardsHeader from 'layouts/Headers/CardsHeader.js';

import TableCustom from 'views/pages/components/TableCustom';
import InputCustom from 'views/pages/components/InputCustom';

import {Button, Card, CardBody, CardHeader, Col, Container, Modal, Row,} from 'reactstrap';

import {deletee, hasPermission, update} from 'views/policies/BusinessActivityPolicy';
import {ButtonContainer} from "@pages/reusable-components/styled-components";
import IcoMoon from "react-icomoon";
import IconSet from "@assets/selection.json";
import notify from '@utils/notify';

export default function BusinessActivity() {

  const permissions = useSelector(state => state.getState).permissions;
  const [token, setToken] = useState('');
  const [loading, setLoading] = useState(true);
  const [activities, setActivities] = useState([]);

  const [activity, setActivity] = useState('');
  const [activityModal, setActivityModal] = useState({
    show: false,
    header: '',
    division: ''
  })

  const [deleteModal, setDeleteModal] = useState({
    show: false,
    header: '',
    body: '',
    onClick: null
  });

  const [errors, setErrors] = useState('');

  useEffect(() => {
    const grs_token = Cookies.get('grs_token')
    setToken(grs_token)

    const source = axios.CancelToken.source()

    const fetchData = async () => {
      try {
        const response = await axios({
          method: 'GET',
          url: `${constants.API_CORE_URL}/business-activity`,
          headers: {
            Authorization: `Bearer ${grs_token}`,
          },
          cancelToken: source.token,
        })
        console.log('response :: ', response.data)
        const data = response.data
        setActivities(data.data)

        setTimeout(() => {
          setLoading(false)
        }, 500);
      } catch (error) {
        setLoading(false)
        if (axios.isCancel(error)) {
          console.log('Request canceled :: ', error)
        } else {
          console.error('error :: ', error)
          notify.warning(error.response && error.response.data ? error.response.data.message : error.response ? error.response.statusText : 'Error Occurred!')
        }
      }
    }

    fetchData()

    return () => {
      source.cancel()
    }
  }, [])

  const addActivity = () => {
    axios({
      method: 'POST',
      url: `${constants.API_CORE_URL}/business-activity`,
      headers: {
        Authorization: `Bearer ${token}`
      },
      data: activity
    })
      .then(response => {
        setErrors('')
        setActivityModal({
          ...activityModal,
          show: false
        })
        setActivity('')
        let data = response.data
        setActivities([...activities,data.data])
        notify.success(data.message)
      })
      .catch(error => {
        setErrors('')
        console.error('error :: ', error)
        if (error.response && error.response.status === 422) {
          setErrors(error.response.data.errors)
          return
        }
        setActivityModal({
          ...activityModal,
          show: false
        })
        notify.warning(error.response ? error.response.statusText : 'Error occurred!')
      })
  }

  const updateActivity = () => {
    axios({
      method: 'PUT',
      url: `${constants.API_CORE_URL}/business-activity/${activity.id}`,
      headers: {
        Authorization: `Bearer ${token}`
      },
      data: activity
    })
      .then(response => {
        setErrors('')
        setActivityModal({
          ...activityModal,
          show: false
        })
        setActivity('')
        let data = response.data
        let idx = activities.findIndex(activity=>activity.id === data.data.id)
        if (idx > -1) {
          let tempActivities = [...activities]
          tempActivities[idx] = data.data
          setActivities(tempActivities)
        }
        notify.success(data.message)
      })
      .catch(error => {
        setErrors('')
        console.error('error :: ', error)
        if (error.response && error.response.status === 422) {
          setErrors(error.response.data.errors)
          return
        }
        setActivityModal({
          ...activityModal,
          show: false
        })
        notify.warning(error.response ? error.response.statusText : 'Error occurred!')
      })
  }

  const deleteActivity = (activityId) => {
    axios({
      method: 'DELETE',
      url: `${constants.API_CORE_URL}/business-activity/${activityId}`,
      headers: {
        Authorization: `Bearer ${token}`
      },
    })
      .then(() => {
        setDeleteModal({
          ...deleteModal,
          show: false
        })
        notify.success()
        let tempActivities = activities.filter(activity=>activity.id !== activityId)
        setActivities(tempActivities)
      })
      .catch(error => {
        console.error('error :: ', error)
        setDeleteModal({
          ...deleteModal,
          show: false
        })
        notify.warning(error.response ? error.response.statusText : 'Error occurred!')
      })
  }

  return (
    <>
      <CardsHeader name="Settings" parentName="Business Activities Management" currentName="List" />
      <Container className="mt--5 admin-main-body" fluid >
        <Row>
          <Col xl="12">
            <Card>
              <CardHeader>
                <Row>
                  <Col xs={8}>
                    <h1 className="mb-0">Business activities</h1>
                    <p className="text-sm mb-0">You can manage Business activities.</p>
                  </Col>
                  <Col xs={4} className="text-right">
                    <ButtonContainer reverse onClick={() => setActivityModal({
                      ...activityModal,
                      show: true,
                      header: 'Add business activity',
                      division: 'create'
                    })}>Add business activity</ButtonContainer>
                  </Col>
                </Row>
              </CardHeader>
              <CardBody>
                <TableCustom
                  loading={loading}
                  keyField={`id`}
                  searchField={false}
                  items={activities}
                  columns={[
                    {
                      dataField: "name",
                      text: "Name",
                      sort: true
                    },

                    {
                      dataField: "",
                      text: "Action",
                      formatter: (rowContent, row) => {
                        return (
                          <>
                            {(hasPermission(permissions, 'update-business-activities') || hasPermission(permissions, 'delete-business-activities')) &&
                            <>
                              {update(permissions, row) &&
                              <IcoMoon
                                  className={'cursor-pointer'}
                                  iconSet={IconSet}
                                  icon={'edit'}
                                  size={24}
                                  onClick={() => {
                                    setActivity(row)
                                    setActivityModal({
                                      ...activityModal,
                                      show: true,
                                      header: 'Edit business activity',
                                      division: 'udpate'
                                    })
                                  }}
                              />
                              }
                              {deletee(permissions, row) &&
                              <IcoMoon
                                  className={'cursor-pointer'}
                                  iconSet={IconSet}
                                  icon={'delete_outline'}
                                  size={24}
                                  onClick={() => setDeleteModal({
                                    ...deleteModal,
                                    show: true,
                                    header: 'Delete business activity',
                                    body: 'Are you sure you want to delete this business activity?',
                                    onClick: () => deleteActivity(row.id)
                                  })}
                              />
                             }
                            </>

                             }
                          </>
                        )
                      }
                    }
                  ]}
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
        <Modal
          isOpen={activityModal.show}
          toggle={() => setActivityModal({
            ...activityModal,
            show: false
          })}
          className="modal-dialog-centered"
        >
          <div className="modal-header">
            <h6 className="modal-title main-color">{activityModal.header}</h6>
            <button
              aria-label="Close"
              className="close"
              data-dismiss="modal"
              type="button"
              onClick={() => setActivityModal({
                ...activityModal,
                show: false
              })}
            >
              <span aria-hidden={true}>×</span>
            </button>
          </div>
          <div className="modal-body">
            <InputCustom
              newLabel={`Name`}
              value={activity && activity.name ? activity.name : ''}
              onChange={e => setActivity({
                ...activity,
                name: e.target.value,
              })}
              invalid={errors && errors.name ? true : false}
              errorMessage={errors.name}
            />
          </div>
          <div className="modal-footer justify-content-end">
            <ButtonContainer
              onClick={() => setActivityModal({
                ...activityModal,
                show: false
              })}
            >
              {`Close`}
            </ButtonContainer>
            <ButtonContainer
                reverse
                onClick={() => activityModal.division === 'create' ? addActivity() : updateActivity()}
            >
              {`Save`}
            </ButtonContainer>
          </div>
        </Modal>
        <Modal
          isOpen={deleteModal.show}
          toggle={() => setDeleteModal({
            ...deleteModal,
            show: false
          })}
          className="modal-dialog-centered"
        >
          <div className="modal-header">
            <h6 className="modal-title">{deleteModal.header}</h6>
            <button
              aria-label="Close"
              className="close"
              data-dismiss="modal"
              type="button"
              onClick={() => setDeleteModal({
                ...deleteModal,
                show: false
              })}
            >
              <span aria-hidden={true}>×</span>
            </button>
          </div>
          <div className="modal-body">
            {`Are you sure you want to delete this business activity?`}
          </div>
          <div className="modal-footer">
            <Button
              className="new-event--add"
              color="danger"
              type="button"
              onClick={deleteModal.onClick}
            >
              {`Delete`}
            </Button>
            <Button
              className="ml-auto"
              color="link"
              type="button"
              onClick={() => setDeleteModal({
                ...deleteModal,
                show: false
              })}
            >
              {`Close`}
            </Button>
          </div>
        </Modal>
      </Container>
    </>
  )
}